/**
 * Decodifica leggera del payload di un JWT, senza dipendenze esterne.
 * Legge il segmento centrale (base64url), lo converte in JSON e ne estrae `exp`.
 */

/** Ritorna la scadenza (claim `exp`) del token in millisecondi epoch, o null se non leggibile. */
export function getTokenExp(token: string): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload['exp'] !== 'number') return null;
  return payload['exp'] * 1000; // `exp` è in secondi -> millisecondi
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;

    // base64url -> base64 + padding
    let base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);

    // atob -> stringa binaria -> UTF-8 corretto
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join(''),
    );
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}
